// Local Imports
import { Result } from "CoreUtils";
import { schema } from "GenAlphaSchema";
import { model } from "GenAlphaModel";
import * as changes from "DrawCore/src/changes";
import { ModeHandler } from "../../modes";
import type { MousePos } from "DrawCore/src/mousepos";
import { InteractionBase } from "../interaction_base";
import { ContentKind } from "DrawCore/src/content/kind";
import { Annotation } from "DrawCore/src/content/shared";
import { Annotations } from "../shared/annotations";
import { GraphicsRender } from "DrawCore/src/content/graphics/render";
import type { InteractionHost } from "../../interaction_host";

type Child = Annotation;
type Selectable = Annotation;

// # Interaction facade
//
// Owns a `GraphicsRender` (composition) and layers the (mostly no-op)
// interaction surface on top.
export class GraphicsContent extends InteractionBase<
  Child,
  Selectable,
  GraphicsRender
> {
  override readonly contentKind = ContentKind.Graphics;

  constructor(editor: InteractionHost, ident?: model.Ident) {
    super(editor, new GraphicsRender(editor));
    if (ident) {
      this.ident = ident;
    }
  }

  // Create a GraphicsContent from schema data
  static fromSchema(
    editor: InteractionHost,
    data: schema.GraphicsContent
  ): Result<GraphicsContent> {
    // FIXME: Convert data.elements to actual graphics elements
    return Result.Ok(new GraphicsContent(editor, data.ident));
  }

  // Bunch of do-nothing methods
  override applyChange = (_: changes.Change<Child>): unknown => null;
  override whatdWeHit = (_: MousePos): null => null;
  override addEntity = (_: Child, __: boolean): unknown => null;
  override removeEntity = (_: Child, __: boolean): boolean => false;
  override idleMode = (): ModeHandler => new IdleMode();

  readonly annotations = new Annotations(this);
  toData = (): schema.GraphicsContent => ({
    schemaVersion: schema.SCHEMA_VERSION,
    contentKind: "graphics",
    ident: this.ident,
    elements: [], // FIXME!
  });
}

// The do-nothing null mode handler
class IdleMode extends ModeHandler {}
